import { Component, Input, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { BaseService } from '../../../providers/base.service';
import { BaseFormComponent } from '../../shared/base-form/base-form.component';

@Component({
  selector: 'app-message-template',
  templateUrl: '../../shared/base-form/base-form.component.html',
  styleUrls: ['./message-template.component.scss']
})
export class MessageTemplateComponent extends BaseFormComponent implements OnInit {
  @Input() recipients;
  @Input() entity;
  hiddenApply = true;
  hiddenReset = true;
  templates: any;
  constructor(
    public cookieService: CookieService,
    public activeModal: NgbActiveModal,
    public titleService: Title,
    public service: BaseService,
    public translator: TranslateService,
  ) {
    super(cookieService, activeModal, titleService, translator, service);
    this.entityName = 'sms';
    this.subentityName = 'template';
  }

  async ngOnInit() {
    this.templates = await this.service.apiCall('api/sms/template', { entity: this.entity }).toPromise();
    await super.ngOnInit();
  }

  async customize(field) {
    if (field.name === 'template') {
      field.type.options = this.templates.map(t => t.title);
    }
    await super.customize(field);
  }

  getApi(): string {
    return 'api/sms/sendTemplate';
  }

  getBody(): any {
    return { recipients: this.recipients };
  }

  async valueChanged(e) {
    if (e.element.id === 'template') {
      if (e.value) {
        const selectedTemplate = this.templates.find(i => i.title === e.value);
        const message_fa = this.form.instance.itemOption('message_fa');
        message_fa['editorOptions']['value'] = selectedTemplate.message_fa;
        this.form.instance.itemOption('account', 'editorOptions', message_fa.editorOptions);
        this.formData.message_fa = selectedTemplate.message_fa;
        const message_en = this.form.instance.itemOption('message_en');
        message_en['editorOptions']['value'] = selectedTemplate.message_en;
        this.form.instance.itemOption('account', 'editorOptions', message_en.editorOptions);
        this.formData.message_en = selectedTemplate.message_en;
      } else {
        this.formData.message_en = '';
        this.formData.message_fa = '';
      }
    }
  }
}
